import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_FineTypeSetup } from "../shared/data.service";
import { FineTypeInUseRequest } from "../shared/FineTypeInUseRequest";
import { FineTypeUpdateRequest } from "../shared/FineTypeUpdateRequest";

@Component({
	selector: "app-admin-setup-edit-fine-type",
	templateUrl: "./admin-setup-edit-fine-type.component.html",
	styleUrls: ["./admin-setup-edit-fine-type.component.css"],
})
export class AdminSetupEditFineTypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private FineTypeSetupService: DataService_FineTypeSetup
	) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedFineType = this.dialogConfig.data.SelectedFineType;

		this.FineCD = this.SelectedFineType.AccountDebitTypeCD;
		this.OriginalCD = this.SelectedFineType.AccountDebitTypeCD;

		this.FineDesc = this.SelectedFineType.AccountDebitTypeDesc;
		this.OriginalDesc = this.SelectedFineType.AccountDebitTypeDesc;

		this.FineAmount = Number(String(this.SelectedFineType.AccountDebitDefaultAmount).replace("$", ""));

		this.DefinedBy = this.SelectedFineType.DefinedByDesc;
	}

	////////////////////////////////
	// Data
	////////////////////////////////

	SchoolID: any;
	SelectedFineType: any;

	//Form
	FineCD: any = "";
	FineDesc: any = "";
	DefinedBy: any = "User";
	FineAmount: any = 0.0;

	OriginalCD: any = "";
	OriginalDesc: any = "";

	errorMessage: any = "";

	////////////////////////////////

	////////////////////////////////
	// Buttons
	////////////////////////////////
	onEdit() {
		if (this.FineCD == "") {
			this.errorMessage = "Enter a code";
			return;
		}
		if (this.FineDesc == "") {
			this.errorMessage = "Enter a description";
			return;
		}

		if (String(this.FineCD) != String(this.OriginalCD)) {
			this.CheckCD();
		} else if (String(this.FineDesc) != String(this.OriginalDesc)) {
			this.CheckDesc();
		} else {
			this.FinishUpdate();
		}
	}

	CheckCD() {
		let parms: FineTypeInUseRequest = {
			str: this.FineCD,
			SchoolID: this.SchoolID,
		};

		var result = this.FineTypeSetupService.FineTypeCDInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Fine Type Code/Abbreviation Already in Use";
					return;
				} else {
					if (String(this.FineDesc) != String(this.OriginalDesc)) {
						this.CheckDesc();
					} else {
						this.FinishUpdate();
					}
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: FineTypeInUseRequest = {
			str: this.FineDesc,
			SchoolID: this.SchoolID,
		};

		var result = this.FineTypeSetupService.FineTypeDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Fine Type Name/Description Already in Use";
					return;
				} else {
					this.FinishUpdate();
				}
			},
			(error) => {}
		);
	}

	FinishUpdate() {
		let parms: FineTypeUpdateRequest = {
			AccountDebitTypeID: this.SelectedFineType.AccountDebitTypeID,
			AccountDebitTypeCD: this.FineCD,
			AccountDebitTypeDesc: this.FineDesc,
			AccountDebitDefaultAmount: this.FineAmount,
		};

		var result = this.FineTypeSetupService.FineTypeUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Fine Type was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Fine Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////
}
